// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../shared/action-creators/busy-counter';
import actions from '../../shared/actions-list';
import {getClaimTypes} from '../../shared/repositories';

export const readClaimTypes = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getClaimTypes();

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_TYPES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/app/action-creators/claim-types.js